import React from 'react';
import { Link } from 'react-router-dom';
 
class SpeakersOne extends React.Component {
    render(){
        return (
            <section id="events" className="speakers-area " >
                <div className="row m-0">
                    <div className="col-lg-4 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/new year.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="">Dazzling New Year Celebrations
                                </Link></h3>
                                <span>Ring in the new year with unforgettable parties that sparkle with joy!
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/beach.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Exotic Destinations
                                </Link></h3>
                                <span>Discover paradise in hidden gems that take your breath away.</span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/trek.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Adventurous Escapes
                                </Link></h3>
                                <span>Step into the wild and feel the rush of thrilling adventures!
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/theme event.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Themed Events</Link></h3>
                                <span>Immerse yourself in creative themes that bring your dreams to life.
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/cultural tours.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Tours</Link></h3>
                                <span>Walk through history and savour the richness of diverse cultures.
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/resort.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Luxury Getaways</Link></h3>
                                <span>Indulge in opulence at destinations where elegance meets serenity.
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 p-0">
                        <div className="single-speakers">
                            <img 
                                src={require("../../assets/images/family.jpg")} 
                                alt="speakers" 
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Family Gatherings</Link></h3>
                                <span>Create precious memories with your loved ones, all in one place.
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 p-0" >
                        <div className="single-speakers" >
                            <img 
                                src={require("../../assets/images/wedding.jpg")} 
                                alt="speakers" 
                                
                              
                            />

                            <div className="speakers-content">
                                <h3><Link to="#">Destination Weddings</Link></h3>
                                <span>Say your vows in dreamy locations that are as special as your love story.
                                </span>
                            </div>
                            {/* <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default SpeakersOne;